import { JsonRpcProvider } from "ethers";
import { NET_ID, NET_NAME } from ".";

/**
 * 根据rpc生成ethers使用的provider，一般用来私钥使用，主账号使用可以直接使用wagmi
 * @param rpc 
 * @returns 
 */
export function getProvider(rpc: any = '') {
  const network = {
    name: NET_NAME, // 替换为您的网络名称
    chainId: NET_ID,         // 替换为您的 Chain ID
  };
  
  const provider = new JsonRpcProvider(rpc, network);


  return provider
}